import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type SendSuggestAppointmentEmailMutationVariables = Types.Exact<{
  input: Types.SendSuggestAppointmentEmailInput
}>

export type SendSuggestAppointmentEmailMutation = {
  __typename?: 'Mutation'
  sendSuggestAppointmentEmail: boolean
}

export const SendSuggestAppointmentEmailDocument = gql`
  mutation SendSuggestAppointmentEmail($input: SendSuggestAppointmentEmailInput!) {
    sendSuggestAppointmentEmail(input: $input)
  }
`
export type SendSuggestAppointmentEmailMutationFn = ApolloReactCommon.MutationFunction<
  SendSuggestAppointmentEmailMutation,
  SendSuggestAppointmentEmailMutationVariables
>
export function useSendSuggestAppointmentEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendSuggestAppointmentEmailMutation,
    SendSuggestAppointmentEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SendSuggestAppointmentEmailMutation,
    SendSuggestAppointmentEmailMutationVariables
  >(SendSuggestAppointmentEmailDocument, options)
}
export type SendSuggestAppointmentEmailMutationHookResult = ReturnType<
  typeof useSendSuggestAppointmentEmailMutation
>
export type SendSuggestAppointmentEmailMutationResult =
  ApolloReactCommon.MutationResult<SendSuggestAppointmentEmailMutation>
export type SendSuggestAppointmentEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SendSuggestAppointmentEmailMutation,
  SendSuggestAppointmentEmailMutationVariables
>
